import Bugsnag from '@bugsnag/js';
import { cacheExchange, Client, fetchExchange, mapExchange } from 'urql';

export const createURQLClient = (endpoint) =>
  new Client({
    url: endpoint,
    exchanges: [
      cacheExchange,
      mapExchange({
        onError,
      }),
      authRefreshExchange,
      fetchExchange,
    ],
    fetch: fetcher,
  });

function onError(error, operation) {
  if (error.networkError) {
    Bugsnag.leaveBreadcrumb('URQL::onError::networkError', {
      networkError: error,
      operation,
    });
  }

  if (error.graphQLErrors) {
    error.graphQLErrors.forEach(({ message, locations, path, extensions }) => {
      Bugsnag.leaveBreadcrumb('URQL::onError::graphqlError', {
        path,
        operation,
        extensions,
        message: message,
        locations: JSON.stringify(locations),
      });
    });
  }
}

export const authRefreshExchange = mapExchange({
  onResult: ({ response }) => {
    if (!response) return;

    const newToken = response.headers.get('X-New-JWT');
    if (newToken && typeof localStorage !== 'undefined') {
      localStorage.setItem('token', newToken);
    }
  },
});

function fetcher(url, options) {
  const { operationName } = JSON.parse(options.body);
  const token = localStorage.getItem('token');
  options.headers['Content-Type'] = 'application/json';
  if (token) {
    options.headers.Authorization = `${token}`;
  }
  return fetch(
    `${url}${operationName ? `?${operationName.toLowerCase()}` : ''}`,
    options
  );
}
